const REGEX = {
  EMAIL_PATTERN: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,63}([-.]\w+)*$/,
  WEBSITE_PATTERN:
    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.(com|org|net|gov|in|edu|io|co|info|biz|co\.uk|us|ca)(\/[^\s]*)?$/,

  INSTAGRAM_PATTERN: /^https:\/\/(www\.)?instagram\.com\/.+$/,
  POSITIVE_PATTERN: /^(?:\d+|\d*\.\d+)$/,
};
export default REGEX;

export const sizeList = ["XS", "S", "M", "L", "XL", "XXL"];
export const colorList = [
  { name: "Black", value: "#000000" },
  { name: "White", value: "#FFFFFF" },
  { name: "Gray", value: "#808080" },
  { name: "Charcoal", value: "#36454F" },
  { name: "Navy", value: "#000080" },
  { name: "Royal Blue", value: "#4169E1" },
  { name: "Sky Blue", value: "#87CEEB" },
  { name: "Turquoise", value: "#40E0D0" },
  { name: "Teal", value: "#008080" },
  { name: "Cobalt", value: "#0047AB" },
  { name: "Azure", value: "#007FFF" },
  { name: "Indigo", value: "#4B0082" },
  { name: "Powder Blue", value: "#B0E0E6" },
  { name: "Red", value: "#FF0000" },
  { name: "Burgundy", value: "#800020" },
  { name: "Maroon", value: "#800000" },
  { name: "Wine", value: "#722F37" },
  { name: "Cherry", value: "#DE3163" },
  { name: "Crimson", value: "#DC143C" },
  { name: "Ruby", value: "#E0115F" },
  { name: "Scarlet", value: "#FF2400" },
  { name: "Brown", value: "#964B00" },
  { name: "Chocolate", value: "#7B3F00" },
  { name: "Coffee", value: "#6F4E37" },
  { name: "Mocha", value: "#967969" },
  { name: "Tan", value: "#D2B48C" },
  { name: "Caramel", value: "#C67C48" },
  { name: "Beige", value: "#F5F5DC" },
  { name: "Cream", value: "#FFFDD0" },
  { name: "Ivory", value: "#FFFFF0" },
  { name: "Off-White", value: "#FAF9F6" },
  { name: "Taupe", value: "#483C32" },
  { name: "Khaki", value: "#C3B091" },
  { name: "Olive", value: "#808000" },
  { name: "Forest Green", value: "#228B22" },
  { name: "Sage", value: "#BCB88A" },
  { name: "Emerald", value: "#50C878" },
  { name: "Mint", value: "#98FF98" },
  { name: "Hunter Green", value: "#355E3B" },
  { name: "Lime", value: "#32CD32" },
  { name: "Purple", value: "#800080" },
  { name: "Lavender", value: "#E6E6FA" },
  { name: "Plum", value: "#8E4585" },
  { name: "Violet", value: "#8F00FF" },
  { name: "Mauve", value: "#E0B0FF" },
  { name: "Amethyst", value: "#9966CC" },
  { name: "Pink", value: "#FFC0CB" },
  { name: "Hot Pink", value: "#FF69B4" },
  { name: "Magenta", value: "#FF00FF" },
  { name: "Rose", value: "#FF007F" },
  { name: "Salmon", value: "#FA8072" },
  { name: "Coral", value: "#FF7F50" },
  { name: "Blush", value: "#DE5D83" },
  { name: "Yellow", value: "#FFFF00" },
  { name: "Gold", value: "#FFD700" },
  { name: "Mustard", value: "#FFDB58" },
  { name: "Orange", value: "#FFA500" },
  { name: "Peach", value: "#FFE5B4" },
  { name: "Amber", value: "#FFBF00" },
  { name: "Apricot", value: "#FBCEB1" },
  { name: "Silver", value: "#C0C0C0" },
  { name: "Bronze", value: "#CD7F32" },
  { name: "Copper", value: "#B87333" },
  { name: "Rose Gold", value: "#B76E79" },
  { name: "Platinum", value: "#E5E4E2" },
];
